import * as Yup from "yup";

import { ApprovalStatus } from "@/app/types/generated/graphql";

export const approvalStatusSchema = Yup.string().notOneOf([ApprovalStatus.Rejected]);
